import styled, { css } from 'styled-components';

const RegistrationButtonIframe = styled.iframe<{ height: number }>`
  border: none;
  width: 100%;
  max-width: 400px;
  ${({ height }) => css`
    height: ${height}px;
  `};
`;

const DivWithCenteredContent = styled.div`
  text-align: center;
`;

export const Styled = {
  RegistrationButtonIframe,
  DivWithCenteredContent,
};
